import { actionTypes } from './actions';
import { reject } from 'lodash';

const initialState = {
  data: null,
  loading: false,
  error: null,
  isCardProcessing: false,
};

export default function bankCardsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_BANK_CARDS_START:
      return { ...state, loading: true, error: null };
    case actionTypes.FETCH_BANK_CARDS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case actionTypes.FETCH_BANK_CARDS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case actionTypes.DELETE_BANK_CARD_START:
      return { ...state, isCardProcessing: true, error: null };
    case actionTypes.DELETE_BANK_CARD_SUCCESS:
      return {
        ...state,
        isCardProcessing: false,
        data: reject(state.data, ['id', action.payload]),
      };
    case actionTypes.DELETE_BANK_CARD_FAILURE:
      return { ...state, isCardProcessing: false, error: action.payload };

    default:
      return state;
  }
}
